import * as RelationRelationApiActions from '@app/modules/relation-relation/actions/relation-relation-api.actions';
import { RelationRelationTableItemModel } from '@app/modules/relation-relation/models/relation-relation-table.model';
import { KeyValueModel } from '@app/shared/models/common/key-value.model';
import { TableOverviewModel } from '@app/shared/models/table/table-overview.model';
import { TableStateModel } from '@app/shared/models/table/table-state.model';
import { applySortingOrDefault } from '@app/shared/utilities/overview-reducer.utilities';
import { createReducer, on } from '@ngrx/store';

const initialState: State = {
    relations: new TableOverviewModel<RelationRelationTableItemModel>('id'),
    relationList: [],
    relationId: 0,
    loading: false,
    errors: {},
};

export interface State {
    relations: TableStateModel<RelationRelationTableItemModel>;
    relationList: KeyValueModel[];
    relationId: number;
    loading: boolean;
    errors: { [key: string]: string[] };
}

export const reducer = createReducer(
    initialState,

    // normal overview
    on(RelationRelationApiActions.GetOverview, (state) => ({
        ...state,
        relations: { ...state.relations, loading: true },
    })),
    on(RelationRelationApiActions.GetOverviewSuccess, (state, response) => ({
        ...state,
        relations: {
            ...state.relations,
            ...response,
            loading: false,
        },
    })),
    on(RelationRelationApiActions.GetOverviewError, (state) => ({
        ...state,
        relations: { ...state.relations, loading: false },
    })),

    on(RelationRelationApiActions.FilterOverview, (state, { relationId, sorting, pagination, thenBy, filter }) => ({
        ...state,
        relationId,
        relations: {
            ...state.relations,
            sorting: applySortingOrDefault(initialState.relations, sorting),
            pagination: {
                ...state.relations.pagination,
                page: pagination.page,
                pageSize: pagination.pageSize,
            },
            filter,
            thenBy,
        },
    })),

    // create
    on(RelationRelationApiActions.Create, (state) => ({ ...state, loading: true, errors: {} })),
    on(RelationRelationApiActions.CreateSuccess, (state) => ({ ...state, loading: false })),
    on(RelationRelationApiActions.CreateError, (state, { response }) => ({
        ...state,
        loading: false,
        errors: response.errors || {},
    })),

    // general
    on(RelationRelationApiActions.ResetOverview, () => ({ ...initialState })),
    on(RelationRelationApiActions.ResetCreate, (state) => ({
        ...initialState,
        relations: state.relations,
        relationId: state.relationId,
    })),

    // activityRelation get

    on(RelationRelationApiActions.GetRelations, (state) => ({ ...state, loading: true })),
    on(RelationRelationApiActions.GetRelationsSuccess, (state, relationList) => ({
        ...state,
        relationList: relationList.relations,
        loading: false,
    })),
    on(RelationRelationApiActions.GetRelationsError, (state, { response }) => ({
        ...state,
        loading: false,
        errors: response.errors || {},
    })),


    // create
    on(RelationRelationApiActions.Create, (state) => ({ ...state, loading: true, errors: {} })),
    on(RelationRelationApiActions.CreateSuccess, (state) => ({ ...state, loading: false })),
    on(RelationRelationApiActions.CreateError, (state, { response }) => ({
        ...state,
        loading: false,
        errors: response.errors || {},
    })),
);

export const getLoading = (state: State) => state.relations.loading;
export const getList = (state: State) => state.relations.list;
export const getPagination = (state: State) => state.relations.pagination;
export const getSorting = (state: State) => state.relations.sorting;
export const getRelationId = (state: State) => state.relationId;
export const getSortingThen = (state: State) => state.relations.thenBy;
export const getFilter = (state: State) => state.relations.filter;
export const getOverview = (state: State) => state.relations;
export const getCreateErrors = (state: State) => state.errors;
export const getCreateLoading = (state: State) => state.loading;
export const getRelations = (state: State) => state.relationList;
